import React, { useEffect } from 'react';
import { Col, Row } from "react-bootstrap";
import { BrowserView, MobileView } from "react-device-detect";
import 'bootstrap/dist/css/bootstrap.min.css';
import logistics from "../../Assets/logistics.jpg";
import bunkering from "../../Assets/bunkering.jpg";
import storage01 from "../../Assets/storage001.png";
import storage02 from "../../Assets/storage002.png";
import storage03 from "../../Assets/storage003.png";
import "./storage.css";
import Aos from "aos";
import "aos/dist/aos.css";

function PhotoWithText({ photoUrl, text }) {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="photo-with-text" style={{ position: 'relative', display: 'inline-block' }}>
      <img src={photoUrl} alt={text} className='storagephoto' style={{ width: '100%' }} />
      <div className="text-overlay head01" style={{
        position: 'absolute',
        width: '100%',
        color: 'white',
        textAlign: 'center'
      }}>
        {text}
      </div>
    </div>
  );
}

function Storage() {
  return (
    <div id="storage">
      {/* Desktop View */}
      <BrowserView className='storagebgclr'>
        <Row>
          <div className='headcenter'>
            <h1>Our Storage</h1>
          </div>
        </Row>

        <Row data-aos="fade-left">
          <div className='bgclr01'>
            <Col><PhotoWithText photoUrl={storage01} text="Hamriyah Freezone" /></Col>
            <Col><PhotoWithText photoUrl={storage02} text="Jurf Industrial Area" /></Col>
            <Col><PhotoWithText photoUrl={storage03} text="Mina Abdullah" /></Col>
          </div>
        </Row>

        <Row className='bgyellow'>
          <Col xs={12} data-aos="fade-left">
            <div className='storagepadding'>
              <h1 className='storagetext'>Logistics & Storage</h1>
              <p className='storagetext'>
                Live Petro offers efficient logistics and storage solutions.
                We provide reliable services for petroleum products,
                including proper loading and unloading of Flexitanks,
                ISO tanks, and IBS tanks.
              </p>
            </div>
          </Col>

          <Col xs={12}>
            <img src={logistics} className="photo" alt="Logistics" />
          </Col>

          <Col xs={12} data-aos="fade-left">
            <div className='storagepadding'>
              <h1 className='storagetext'>Bunkering</h1>
              <p className='storagetext'>
                We provide fuel for ships, including logistics for loading and distributing the fuel efficiently.
                We deal in Intermediate Fuel Oil (IFO) 380 CST RMG, IFO 180 CST RME, and Low Sulfur Marine Gas Oil (LSMGO)
                to meet various fuel requirements.
              </p>
            </div>
          </Col>

          <Col xs={12}>
            <img src={bunkering} className="photo" alt="Bunkering" />
          </Col>
        </Row>
      </BrowserView>

      {/* Mobile View */}
      <MobileView className='storagebgclrmob'>
        <Row>
          <div className='headcenter'>
            <h1>Our Storage</h1>
          </div>
        </Row>

        <div className="p-5 pt-0 pb-5" data-aos="fade-left">
          <PhotoWithText photoUrl={storage01} text="Hamriyah Freezone" />
        </div>
        <div className="p-5 pt-0 pb-5" data-aos="fade-right">
          <PhotoWithText photoUrl={storage02} text="Jurf Industrial Area" />
        </div>
        <div className="p-5 pt-0" data-aos="fade-left">
          <PhotoWithText photoUrl={storage03} text="Mina Abdullah" />
        </div>

        <Row className='bgyellow'>
          <Col xs={12} data-aos="fade-left">
            <div className='p-5'>
              <h1 className='storagetext'>Logistics & Storage</h1>
              <p className='storagetext'>
                Live Petro offers efficient logistics and storage solutions.
                Reliable services for loading and unloading Flexitanks, ISO tanks, and IBS tanks.
              </p>
            </div>
          </Col>
          <Col xs={12}>
            <img src={logistics} className="photo" alt="Logistics" />
          </Col>
        </Row>

        <Row className='bgyellow'>
          <Col xs={12} data-aos="fade-right">
            <div className='p-5'>
              <h1 className='storagetext'>Bunkering</h1>
              <p className='storagetext'>
                We provide fuel for ships, including logistics for loading and distribution.
                We deal in IFO 380 CST RMG, IFO 180 CST RME, and LSMGO.
              </p>
            </div>
          </Col>
          <Col xs={12}>
            <img src={bunkering} className="photo" alt="Bunkering" />
          </Col>
        </Row>
      </MobileView>
    </div>
  );
}

export default Storage;
